<template>
  <el-dialog :title="title" :visible.sync="visible" :close-on-click-modal="false" class="accountSet" @close="cancel">
    <p v-if="type === 'bindEmail'" class="color-gray-9">{{ $t('setting.Tips3') }}</p>
    <el-form ref="accountForm" label-position="top" label-width="140px" :model="accountForm" :rules="accountFormRules">
      <el-form-item v-if="type === 'fullName'" :label="$t('PersonalCenter.AccountSetting.Index.FullName')" prop="fullName">
        <el-input v-model="accountForm.fullName" :placeholder="$t('setting.fullNamePlaceholder')" style="width: 100%;"></el-input>
      </el-form-item>
      <el-form-item v-if="type === 'email' || type === 'bindEmail'" :label="$t('PersonalCenter.AccountSetting.Index.Email')" prop="email">
        <el-input v-model.trim="accountForm.email" :placeholder="$t('setting.emailPlaceholder')" style="width: 100%;"></el-input>
      </el-form-item>
      <el-form-item v-if="type === 'phone'" :label="$t('PersonalCenter.AccountSetting.Index.Phone')" prop="phone">
        <!-- <el-input v-model="accountForm.phone" style="width: 100%;"></el-input> -->
        <el-input v-model.trim="accountForm.phone" @input="checkPhone" :placeholder="$t('setting.phonePlaceholder')">
          <el-select v-model="accountForm.areaCode" filterable slot="prepend" style="width:88px;">
            <el-option v-for="item in areaCodeList" :label="item.areaCode" :value="item.areaCode" :key="item.countryCode+item.areaCode">
              <span style="float:left;font-size:13px;color:#909399;">{{ item.countryNameEn }}</span>
              <span style="float:right;font-size:13px;color:#303133;">{{item.areaCode}}</span>
            </el-option>
          </el-select>
        </el-input>
      </el-form-item>
      <el-form-item v-if="type !== 'fullName'" :label="$t('PersonalCenter.AccountSetting.Components.AccountSettingDialog.VerificationCode')" prop="verificationCode">
        <el-input v-model="accountForm.verificationCode" :placeholder="$t('setting.verificationCodePlaceholder')" style="width: 100%;">
          <template slot="append">
            <span :loading="loading" class="pointer" size="large" @click="sendVertificationCode" v-if="seconds===0">
              <el-button>{{sendText}}</el-button>
            </span>
          </template>
        </el-input>
        <p style="padding:0;" v-if="seconds>0">{{ $t('PersonalCenter.AccountSetting.Components.AccountSettingDialog.Tips2') }} <span style="color: #99C41C!important;">{{seconds}}</span>s {{ $t('PersonalCenter.AccountSetting.Components.AccountSettingDialog.later') }}</p>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="cancel">{{$t('currency.cancel')}}</el-button>
      <el-button size="small" type="primary" @click="submit">{{$t('currency.submit')}}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import API from '@/api'
import { encrypt } from '@/util/encryp.js'
import { pureNumber, checkEmail, telephoneNumber, generalPhoneNumber } from '@/util/validate'
let checkPureNumber = (rules, value, callback) => {
  if (pureNumber(value)) {
    callback()
  } else {
    callback(new Error(`${this.$t('PersonalCenter.AccountSetting.Components.AccountSettingDialog.Tips3')}`))
  }
}
let validateEmail = (rule, value, callback) => {
  if (checkEmail(value)) {
    callback()
  } else {
    callback(new Error('Please enter your vaild email'))
  }
}
let checkPhoneNumber = (rules, value, callback) => {
  if (telephoneNumber(value) || generalPhoneNumber(value)) {
    callback()
  } else {
    callback(new Error('Please enter your valid phoneNumber'))
  }
}

export default {
  data() {
    return {
      visible: false,
      type: 'fullName',
      title: '',
      accountForm: {},
      accountFormRules: {
        fullName: [{ required: true, message: this.$t('Home.Register.FullNameCheck1'), trigger: 'blur' }, { min: 2, max: 255, trigger: 'blur', message: this.$t('Home.Register.FullNameCheck2') }],
        email: [{ validator: validateEmail, trigger: 'blur' }, { required: true, message: 'Please enter your vaild email', trigger: 'blur' }],
        phone: [{ validator: checkPhoneNumber, trigger: 'blur' }, { required: true, message: 'Please enter your vaild Phone Number', trigger: 'blur' }],
        verificationCode: [{ validate: checkPureNumber, trigger: 'blur' }, { required: true, message: '', trigger: ['change', 'blur'] }]
      },
      loading: false,
      seconds: 0,
      timer: null,
      sendText: 'Send',
      passCheck: false
    }
  },
  created() {
    this.systemAddressInfo()
  },
  methods: {
    show(type) {
      this.type = type
      if (type === 'email') {
        this.title = this.$t('setting.UpdateEmail')
      } else if (type === 'phone') {
        this.title = this.$t('setting.UpdatePhone')
        this.$set(this.accountForm, 'areaCode', '+1')
      } else if (type === 'bindEmail') {
        this.title = this.$t('setting.EmailSettings')
      } else {
        this.title = this.$t('setting.updateName')
        this.$set(this.accountForm, 'fullName', this.$store.state.common.userName)
      }
      this.visible = !this.visible
    },
    // 校验输入的电话号码（只能为数字）
    checkPhone() {
      this.accountForm.phone = this.accountForm.phone.replace(/\D/g, '')
    },
    sendVertificationCode() {
      this.loading = true
      let param = { userId: this.$store.state.common.userId }
      if (this.type === 'email' || this.type === 'bindEmail') {
        if (!this.accountForm.email) {
          return this.$message.warning(this.$t('setting.emailPlaceholder'))
        }
        param.email = this.accountForm.email
      }
      if (this.type === 'phone') {
        if (!this.accountForm.phone) {
          return this.$message.warning(this.$t('setting.phonePlaceholder'))
        }
        param.phone = `${this.accountForm.areaCode} ${this.accountForm.phone}`
      }
      param.token = encrypt(param.email + Math.random())
      API.getEmailAuthentication(param).then((res) => {
        if (res.code !== 10000) return this.$message.error(res.message)
        this.disabled = true
        this.sendText = 'Send Again'
        this.seconds = 60
        this.timer = setInterval(() => {
          if (this.seconds <= 0) {
            clearInterval(this.timer)
            this.timer = null
            this.disabled = false
            this.$forceUpdate()
            return
          }
          --this.seconds
        }, 1000)
      }).catch(result => {
        this.$message.error(result.data.message)
        this.disabled = false
      }).finally(() => {
        this.loading = false
      })
    },
    // 验证验证码
    checkVerificationCode() {
      let form = { verificationCode: this.accountForm.verificationCode }
      if (this.type === 'email' || this.type === 'bindEmail') form.email = this.accountForm.email
      if (this.type === 'phone') form.phone = `${this.accountForm.areaCode} ${this.accountForm.phone}`
      if ((form.email || form.phone) && form.verificationCode) {
        API.checkVerificationCode(form).then(res => {
          if (res.code === 10000) this.accountSetting()
          else this.$message.error(res.message)
        }).catch(result => {
          this.$message.error(result.data.message)
        })
      }
    },
    cancel() {
      this.accountForm = {}
      this.$refs.accountForm.resetFields()
      this.sendText = 'Send'
      this.seconds = 0
      this.visible = false
    },
    submit() {
      this.$refs.accountForm.validate(valid => {
        if (!valid) return
        if (this.type === 'fullName') {
          this.accountSetting()
        } else {
          this.checkVerificationCode()
        }
      })
    },

    // 更改账号名
    accountSetting() {
      // if (!this.accountForm.fullName) {
      //   this.accountForm.fullName = this.$store.state.common.userName
      //   this.$message.warning(this.$t('Home.Register.FullNameCheck1'))
      //   return
      // }
      // if (this.accountForm.fullName.length < 2 || this.accountForm.fullName.length > 255) {
      //   this.accountForm.fullName = this.$store.state.common.userName
      //   this.$message.warning(this.$t('Home.Register.FullNameCheck2'))
      //   return
      // }
      let param = { userId: this.$store.state.common.userId }
      if (this.type === 'email' || this.type === 'bindEmail') param.email = this.accountForm.email
      if (this.type === 'phone') param.phone = `${this.accountForm.areaCode} ${this.accountForm.phone}`
      if (this.type === 'fullName') param.fullName = this.accountForm.fullName
      API.accountSetting(param).then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        this.$message.success(this.$t('common.success'))
        let set = {}
        if (this.type === 'email' || this.type === 'bindEmail') set.email = this.accountForm.email
        if (this.type === 'phone') set.phone = `${this.accountForm.areaCode} ${this.accountForm.phone}`
        if (this.type === 'fullName') set.userName = this.accountForm.fullName
        this.$store.commit('common/set', set)
        this.$emit('setSuccess')
        this.cancel()
      })
    },

    systemAddressInfo() {
      API.systemAddressInfo().then(res => {
        this.areaCodeList = res.data
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.accountSet {
  /deep/.el-dialog {
    width: 90%;
    max-width: 550px;
  }
  /deep/.el-dialog__body {
    padding: 10px 28px;
  }

  /deep/ .el-form-item__label {
    padding-bottom: 0;
  }

  /deep/ .el-input-group__prepend{
    background-color: unset;
  }
}
</style>
